module.exports = __webpack_public_path__ + "img/food_intro3_opt.553f11f0.jpg";